export const vi = {
  // Common
  "common.back": "Quay lại",
  "common.cancel": "Hủy",
  "common.noItems": "Không có mục nào",
  "common.loading": "Đang tải...",
  
  // Header
  "nav.features": "Tính năng",
  "nav.howItWorks": "Cách thức hoạt động",
  "nav.pricing": "Giá cả",
  "nav.faq": "Câu hỏi thường gặp",
  "nav.testimonials": "Bộ sưu tập",
  "nav.contact": "Liên hệ",
  "button.getStarted": "Bắt đầu",
  "button.loading": "Đang tải...",

  // Auth related
  "auth.signIn": "Đăng nhập",
  "auth.redirecting": "Đang chuyển hướng...",
  "auth.continueWithGoogle": "Tiếp tục với Google",
  "auth.continueWithGithub": "Tiếp tục với GitHub",
  "auth.or": "HOẶC",
  "auth.consent.prefix": "Bằng việc tiếp tục, bạn đồng ý với",
  "auth.consent.terms": "Điều khoản",
  "auth.consent.and": "và",
  "auth.consent.privacy": "Chính sách bảo mật",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "Trợ lý giao tiếp AI",
  "hero.subtitle": "Biến đổi các cuộc trò chuyện của bạn với những phản hồi thông minh, nhận thức bối cảnh giúp bạn giao tiếp hiệu quả hơn trong mọi tình huống.",
  "hero.cta.primary": "Dùng thử miễn phí",
  "hero.cta.secondary": "Xem demo",
  "hero.cta.tryNow": "Bắt đầu miễn phí",
  "hero.cta.learnMore": "Tìm hiểu thêm",
  "hero.cta.getStarted": "Bắt đầu miễn phí",
  "hero.preview.primary": "Hoàn thiện giọng điệu",
  "hero.preview.secondary": "Dịch",
  "hero.preview.tone": "Thân thiện",
  "hero.preview.target": "Khách hàng",
  "hero.hook": "Tham gia cùng hàng ngàn người dùng đang cải thiện giao tiếp của họ mỗi ngày.",
  "hero.headline": "Trợ lý giao tiếp AI",
  "hero.subheadline": "Biến ý tưởng thô ráp thành phản hồi tinh tế, nhận thức bối cảnh trong vài giây.",
  
  // Stats
  "stats.users": "Người dùng",
  "stats.replies": "Phản hồi",
  "stats.languages": "Ngôn ngữ",

  // Main Title
  "main.title": "Biến mỗi phản hồi thành cơ hội",

  // Footer Section
  "footer.company": "Công ty",
  "footer.product": "Sản phẩm",
  "footer.support": "Hỗ trợ",
  "footer.legal": "Pháp lý",
  "footer.contactSupport": "Liên hệ hỗ trợ",
  "footer.helpCenter": "Trung tâm trợ giúp",
  "footer.apiDocs": "Tài liệu API",
  "footer.statusPage": "Trang trạng thái",
  "footer.privacyPolicy": "Chính sách bảo mật",
  "footer.termsOfService": "Điều khoản dịch vụ",
  "footer.cookiePolicy": "Chính sách cookie",
  "footer.refundPolicy": "Chính sách hoàn tiền",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Hỗ trợ",

  // Features Section
  "features.badge": "Tính năng mạnh mẽ",
  "features.title": "Tất cả những gì bạn cần để giao tiếp tốt hơn",
  "features.subtitle": "Các công cụ toàn diện được thiết kế để làm cho mọi cuộc trò chuyện hiệu quả và chuyên nghiệp hơn.",
  "features.scenario.title": "Mẫu kịch bản",
  "features.scenario.description": "Các mẫu được xây dựng sẵn cho giao tiếp nơi làm việc, cá nhân, học thuật và chuyên nghiệp.",
  "features.custom.title": "Đầu vào tùy chỉnh",
  "features.custom.description": "Dán bất kỳ tin nhắn hoặc nội dung nào và nhận được phản hồi phù hợp với ngữ cảnh.",
  "features.instant.title": "Giảm 90% thời gian phản hồi",
  "features.instant.description": "Nhận phản hồi do AI tạo ra trong vài giây. Không chờ đợi, chỉ có kết quả.",
  "features.copy.title": "Sao chép & Chia sẻ một cú nhấp",
  "features.copy.description": "Sao chép phản hồi ngay lập tức hoặc chia sẻ trực tiếp từ nền tảng.",

  // How It Works Section
  "howItWorks.badge": "Cách thức hoạt động",
  "howItWorks.title": "Ba bước đơn giản để giao tiếp tốt hơn",
  "howItWorks.subtitle": "Quy trình đơn giản hóa của chúng tôi giúp dễ dàng tạo ra phản hồi chuyên nghiệp cho mọi tình huống.",
  "howItWorks.step1.title": "Chọn kịch bản",
  "howItWorks.step1.description": "Chọn kịch bản giao tiếp phù hợp nhất với nhu cầu của bạn.",
  "howItWorks.step2.title": "Dán nội dung",
  "howItWorks.step2.description": "Thêm tin nhắn hoặc nội dung bạn cần phản hồi.",
  "howItWorks.step3.title": "Nhận phản hồi AI",
  "howItWorks.step3.description": "Nhận phản hồi chuyên nghiệp, nhận thức bối cảnh trong vài giây.",

  // Pricing Section
  "pricing.title": "Giá cả",
  "pricing.subtitle": "Chọn gói phù hợp với nhu cầu giao tiếp của bạn",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/tháng",
  "pricing.free.description": "Hoàn hảo để thử dịch vụ của chúng tôi",
  "pricing.pro.description": "Lý tưởng cho chuyên gia và người dùng thường xuyên",
  "pricing.business.description": "Cho nhóm và tổ chức",
  "pricing.popular": "Phổ biến nhất",
  "pricing.free.feature1": "10 phản hồi mỗi tháng",
  "pricing.free.feature2": "Kịch bản cơ bản",
  "pricing.free.feature3": "Xác định và sử dụng mẫu",
  "pricing.free.feature4": "Lịch sử phản hồi",
  "pricing.pro.feature1": "200 phản hồi mỗi tháng",
  "pricing.pro.feature2": "Kịch bản cơ bản+tùy chỉnh",
  "pricing.pro.feature3": "Xác định và sử dụng mẫu",
  "pricing.pro.feature4": "Lịch sử phản hồi",
  "pricing.pro.feature5": "Tùy chỉnh nâng cao",
  "pricing.business.feature1": "Phản hồi không giới hạn",
  "pricing.business.feature2": "Hợp tác nhóm",
  "pricing.business.feature3": "Kịch bản cơ bản+tùy chỉnh",
  "pricing.business.feature4": "Xác định và sử dụng mẫu",
  "pricing.business.feature5": "Lịch sử phản hồi",
  "pricing.business.feature6": "Tùy chỉnh nâng cao",
  "pricing.cta.trial": "Bắt đầu dùng thử miễn phí",
  "pricing.cta.subscribe": "Đăng ký",
  "pricing.cta.contact": "Liên hệ bán hàng",
  "pricing.cta.current": "Gói hiện tại",
  "pricing.currentPlan": "Gói hiện tại:",
  "pricing.endDate": "Ngày kết thúc gói hiện tại:",
  "pricing.autoRenewalDate": "Ngày gia hạn tự động gói hiện tại:",
  "pricing.answersLeft": "Phản hồi còn lại:",
  "pricing.planName.free": "Dự án Free",
  "pricing.planName.proMonthly": "Gói Pro nghiệp-Tháng",
  "pricing.planName.proYearly": "Gói Pro nghiệp-Năm",
  "pricing.planName.maxMonthly": "Gói Enterprise nghiệp-Tháng",
  "pricing.planName.maxYearly": "Gói Enterprise nghiệp-Năm",
  "pricing.autoRenews": "Số lượng phản hồi của bạn sẽ tự động gia hạn vào:",
  "pricing.needMore": "Cần thêm phản hồi?",
  "pricing.upgradeBelow": "Nâng cấp gói của bạn bên dưới",
  "pricing.doNotRollOver": "Phản hồi chưa sử dụng không được chuyển tiếp",
  "pricing.willCancelOn": "Sẽ hủy vào:",
  "pricing.downgradeScheduled": "Đã lên lịch hạ cấp. Sẽ chuyển sang",
  "pricing.on": "vào:",
  "pricing.upgradeImmediateTitle": "Đã nâng cấp gói",
  "pricing.upgradeImmediateDesc": "Gói mới của bạn hiện đang hoạt động.",
  "pricing.downgradeScheduledTitle": "Đã lên lịch hạ cấp",
  "pricing.downgradeScheduledDesc": "Gói của bạn sẽ thay đổi khi gia hạn tiếp theo.",
  "pricing.cancelScheduledTitle": "Đã lên lịch hủy",
  "pricing.cancelScheduledDesc": "Gói của bạn sẽ kết thúc vào cuối kỳ.",
  "pricing.cancelResumedTitle": "Đã xóa hủy",
  "pricing.cancelResumedDesc": "Đăng ký của bạn sẽ tiếp tục gia hạn.",
  "pricing.cancelPendingDowngrade": "Hủy",
  "pricing.pendingDowngradeCanceledTitle": "Đã hủy hạ cấp đang chờ xử lý",
  "pricing.pendingDowngradeCanceledDesc": "Gói của bạn sẽ giữ nguyên không thay đổi.",
  "pricing.pendingDowngradeCancelFailedTitle": "Hủy không thành công",
  "pricing.pendingDowngradeCancelFailedDesc": "Không thể hủy hạ cấp đang chờ xử lý. Vui lòng thử lại.",
  "pricing.cancelPendingDowngradeProcessing": "Đang xử lý...",
  "pricing.scheduled": "Đã lên lịch",
  "pricing.processing": "Đang xử lý...",
  "pricing.getMoreReplies": "Nhận thêm phản hồi",
  "pricing.oneTimeTitle": "Nhận thêm phản hồi cho tài khoản của bạn",
  "pricing.oneTimeAmountLabel": "Số tiền (USD)",
  "pricing.repliesUnit": "Phản hồi",
  "pricing.oneTimeNotice": "Số lượng phản hồi bạn mua có hiệu lực trong chu kỳ tháng hiện tại. Cần có đăng ký trả phí đang hoạt động để sử dụng và phản hồi chưa sử dụng không được chuyển tiếp.",
  "pricing.cancel": "Hủy",
  "pricing.proceed": "Tiếp tục",
  "pricing.confirmUpgradeTitle": "Xác nhận nâng cấp",
  "pricing.confirmDowngradeTitle": "Xác nhận hạ cấp",
  "pricing.confirmUpgradeDesc": "Bạn sắp nâng cấp gói của mình. Thay đổi sẽ có hiệu lực ngay lập tức và có thể áp dụng phí (hoặc tín dụng) theo tỷ lệ.",
  "pricing.confirmDowngradeDesc": "Bạn sắp lên lịch hạ cấp. Các tính năng hiện tại của bạn sẽ vẫn giữ nguyên đến hết chu kỳ thanh toán hiện tại.",
  "pricing.downgradeEffectNote": "Hạ cấp không hoàn tiền chu kỳ hiện tại.",
  "pricing.downgradeApplyNextCycle": "Gói mới sẽ bắt đầu tự động khi gia hạn.",
  "pricing.confirmCancel": "Quay lại",
  "pricing.confirmProceedUpgrade": "Nâng cấp ngay",
  "pricing.confirmProceedDowngrade": "Lên lịch hạ cấp",

  // FAQ Section
  "faq.title": "Câu hỏi thường gặp",
  "faq.subtitle": "Tất cả những gì bạn cần biết về communicate2win",
  "faq.q1": "Hỗ trợ những kịch bản giao tiếp nào?",
  "faq.a1": "Chúng tôi hỗ trợ giao tiếp nơi làm việc, mối quan hệ cá nhân, thư tín học thuật, dịch vụ khách hàng, tiếp cận bán hàng và nhiều kịch bản khác. AI của chúng tôi thích ứng với bối cảnh và giọng điệu cần thiết cho từng tình huống.",
  "faq.q2": "Phản hồi được tạo ra nhanh như thế nào?",
  "faq.a2": "AI của chúng tôi tạo ra phản hồi trong vài giây. Chúng tôi ưu tiên tốc độ mà không ảnh hưởng đến chất lượng, đảm bảo bạn nhận được phản hồi chuyên nghiệp ngay lập tức.",
  "faq.q3": "Tôi có thể hủy đăng ký bất cứ lúc nào không?",
  "faq.a3": "Có, bạn có thể hủy đăng ký bất cứ lúc nào. Không có cam kết dài hạn, và bạn có thể hạ cấp hoặc nâng cấp gói theo nhu cầu.",
  "faq.q4": "Dữ liệu của tôi có an toàn và riêng tư không?",
  "faq.a4": "Có, chúng tôi triển khai các biện pháp bảo mật toàn diện bao gồm mã hóa, kiểm soát truy cập và kiểm toán bảo mật định kỳ. Nội dung đầu vào và phản hồi được tạo ra của bạn được lưu trữ như một phần trong lịch sử người dùng để bật các tính năng như xem lại phản hồi và tạo mẫu. Bạn có thể xóa dữ liệu lịch sử bất cứ lúc nào thông qua cài đặt tài khoản.",
  "faq.q5": "Nếu tôi dùng hết Replies thì sao?",
  "faq.a5": "Người dùng Free phải đợi tới chu kỳ tháng tiếp theo để làm mới hạn mức. Sau khi nâng cấp lên Pro, nếu hết Replies bạn có thể mua thêm Replies một lần; số Replies thêm chỉ có hiệu lực trong chu kỳ tháng hiện tại. Người dùng Enterprise có Replies không giới hạn.",
  "faq.q6": "Hỗ trợ những ngôn ngữ nào?",
  "faq.a6": "Hiện tại, chúng tôi hỗ trợ tiếng Anh với kế hoạch mở rộng sang tiếng Tây Ban Nha, tiếng Pháp, tiếng Đức và các ngôn ngữ chính khác. AI có thể xử lý giao tiếp đa ngôn ngữ một cách hiệu quả.",

  // Testimonials Section
  "testimonials.title": "Bộ sưu tập giao tiếp",
  "testimonials.subtitle": "Tin nhắn công khai, email và phản hồi được AI tinh chỉnh để truyền cảm hứng cho bạn",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Giám đốc Marketing",
  "testimonials.sarah.quote": "communicate2win đã thay đổi cách tôi xử lý giao tiếp với khách hàng. Phản hồi rất chuyên nghiệp và tiết kiệm cho tôi hàng giờ mỗi tuần.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Quản lý Bán hàng",
  "testimonials.michael.quote": "Các mẫu kịch bản nơi làm việc cực kỳ chính xác. Tỷ lệ phản hồi của tôi đã cải thiện 40% kể từ khi sử dụng công cụ này.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Trưởng nhóm Thành công Khách hàng",
  "testimonials.emily.quote": "Hoàn hảo để xử lý các tình huống khách hàng khó khăn. AI hiểu hoàn hảo bối cảnh và giọng điệu.",
  "testimonials.more": "Nhấp vào bộ sưu tập để khám phá toàn bộ trưng bày",

  // Interface Elements
  "interface.generating": "Đang tạo phản hồi...",
  "interface.generate": "Tạo phản hồi AI",
  "interface.processing": "Đang xử lý...",
  "interface.advancedOptions": "Tùy chọn nâng cao",
  "interface.clearInput": "Xóa đầu vào",
  "interface.clearDescription": "Xóa mô tả",
  // Marquee / Logos
  "marquee.trusted": "Đối tác / Hỗ trợ",
  "marquee.aria": "Logo thương hiệu",

  // History and Showcase
  "history.shareToShowcase": "Chia sẻ tới bộ sưu tập",
  "history.showcased": "Đã trưng bày",
  "history.shareConfirm": "Chia sẻ bài đăng này tới bộ sưu tập? Hành động này không thể hoàn tác trừ khi bạn xóa bài đăng.",
  "history.sharedBy": "Được chia sẻ bởi:",
  "interface.copy": "Sao chép",
  "interface.share": "Chia sẻ",
  "interface.shareResponse": "Chia sẻ phản hồi",
  "interface.shareNative": "Chia sẻ qua hệ thống",
  "interface.shareEmail": "Email",
  "interface.copyShareText": "Sao chép kèm liên kết",
  "interface.shareTextCopied": "Phản hồi và liên kết đã được sao chép vào clipboard.",
  "interface.ready": "Sẵn sàng tạo",
  "interface.enterMessage": "Nhập nội dung tin nhắn của bạn và chọn một kịch bản để bắt đầu với phản hồi được hỗ trợ bởi AI.",
  "interface.fast": "Nhanh chóng",
  "interface.accurate": "Chính xác",
  "interface.professional": "Chuyên nghiệp",
  "interface.translation": "Dịch",
  "interface.responseDescription": "Đây là phản hồi được cân nhắc và chuyên nghiệp phù hợp với bối cảnh:",
  "interface.multipleOptions": "Nhiều tùy chọn phản hồi:",
  "interface.option": "Tùy chọn",
  "interface.noContent": "Không có nội dung khả dụng",

  // Placeholders
  "placeholder.message": "Dán tin nhắn bạn đang phản hồi, nội dung email hoặc văn bản bạn đã nhận...",

  // Dropdowns
  "dropdown.useTemplates": "Sử dụng mẫu",
  "dropdown.scenario": "Không có kịch bản",
  "dropdown.target": "Không có mục tiêu",
  "dropdown.tone": "Không có giọng điệu",

  // Scenario Options
  "scenario.email": "Email",
  "scenario.message": "Tin nhắn",
  "scenario.workplace": "Nơi làm việc",
  "scenario.school": "Trường học",
  "scenario.home": "Nhà",
  "scenario.business": "Kinh doanh",
  "scenario.academic": "Học thuật",
  "scenario.social": "Xã hội",
  "scenario.formal": "Trang trọng",
  "scenario.casual": "Bình thường",
  "scenario.professional": "Chuyên nghiệp",
  "scenario.personal": "Cá nhân",
  "scenario.customerService": "Dịch vụ khách hàng",
  "scenario.interview": "Phỏng vấn",
  "scenario.presentation": "Thuyết trình",

  // Target Options
  "target.lover": "Người yêu",
  "target.friend": "Bạn bè",
  "target.boss": "Sếp",
  "target.colleague": "Đồng nghiệp",
  "target.classmate": "Bạn học",
  "target.parents": "Cha mẹ",
  "target.child": "Con cái",
  "target.teacher": "Giáo viên",
  "target.student": "Học sinh",
  "target.client": "Khách hàng",
  "target.customer": "Khách hàng",
  "target.stranger": "Người lạ",
  "target.family": "Gia đình",
  "target.sibling": "Anh chị em",
  "target.neighbor": "Hàng xóm",
  "target.mentor": "Cố vấn",
  "target.supplier": "Nhà cung cấp",
  "target.serviceProvider": "Nhà cung cấp dịch vụ",
  "target.partner": "Đối tác",
  "target.subordinate": "Cấp dưới",

  // Tone Options
  "tone.humorous": "Hài hước",
  "tone.serious": "Nghiêm túc",
  "tone.happy": "Vui vẻ",
  "tone.angry": "Tức giận",
  "tone.mischievous": "Tinh nghịch",
  "tone.polite": "Lịch sự",
  "tone.casual": "Bình thường",
  "tone.formal": "Trang trọng",
  "tone.friendly": "Thân thiện",
  "tone.confident": "Tự tin",
  "tone.apologetic": "Xin lỗi",
  "tone.enthusiastic": "Hăng hái",

  // Status Messages
  "status.copied": "Đã sao chép!",
  "status.copyDescription": "Phản hồi đã được sao chép vào clipboard.",
  "status.copyWithTranslationDescription": "Phản hồi và bản dịch đã được sao chép vào clipboard.",
  "status.success": "Đã tạo phản hồi thành công.",
  "status.successWithTranslation": "Đã tạo phản hồi với bản dịch.",
  "status.successWithoutTranslation": "Đã tạo phản hồi thành công.",
  "status.error": "Tạo không thành công",
  "status.errorDescription": "Không thể tạo phản hồi. Vui lòng thử lại.",
  "status.enterContent": "Vui lòng nhập nội dung",
  "status.enterContentDescription": "Thêm tin nhắn bạn muốn phản hồi.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Mô tả (tùy chọn)",
  "restriction.descriptionLabel": "Mô tả (Chỉ dành cho người đăng ký Pro / Enterprise)",
  "restriction.proMaxOnly": "* Chỉ dành cho người đăng ký Pro / Enterprise",
  "restriction.desPrompt": "Nhập bối cảnh, thông tin nền hoặc yêu cầu cụ thể có thể giúp tạo ra phản hồi tốt hơn...",

  // Demo functionality for non-logged-in users
  "demo.title": "Chọn một tin nhắn để phản hồi",
  "demo.option1": "Mở đầu bán hàng (tiếp cận lạnh)",
  "demo.option2": "Xử lý câu hỏi \"giá của bạn cao\"",
  "demo.option3": "Giới thiệu bản thân trong phỏng vấn (phiên bản 30 giây)",
  "demo.option4": "Phản hồi email",
  "demo.option5": "Theo dõi cho khả năng \"đã đọc-nhưng-không-phản-hồi\"",
  "demo.option6": "Bài thuyết trình thang máy (30 giây)",
  "demo.runDemo": "Chạy Demo",
  "demo.inputContent": "Nội dung đầu vào:",
  "demo.scenario": "Kịch bản:",
  "demo.target": "Mục tiêu:",
  "demo.tone": "Giọng điệu:",
  "demo.description": "Mô tả:",

  // Showcase Page
  "showcase.title": "Bộ sưu tập giao tiếp",
  "showcase.subtitle": "Khám phá giao tiếp truyền cảm hứng được hỗ trợ bởi AI được chia sẻ bởi cộng đồng của chúng tôi",
  "showcase.userPrefix": "Giao tiếp công khai bởi",
  "showcase.backAll": "Quay lại tất cả trưng bày",
  "showcase.sortBy": "Sắp xếp theo:",
  "showcase.sort.newest": "Mới nhất trước",
  "showcase.sort.oldest": "Cũ nhất trước",
  "showcase.sort.scenario": "Theo kịch bản",
  "showcase.sort.target": "Theo mục tiêu",
  "showcase.sort.tone": "Theo giọng điệu",
  "showcase.filter.scenario": "Kịch bản:",
  "showcase.filter.target": "Mục tiêu:",
  "showcase.filter.tone": "Giọng điệu:",
  "showcase.filter.all": "Tất cả",
  "showcase.loading": "Đang tải bộ sưu tập...",
  "showcase.loadingUser": "Đang tải giao tiếp người dùng...",
  "showcase.loadingMore": "Đang tải thêm...",
  "showcase.none.userTitle": "Chưa có giao tiếp công khai",
  "showcase.none.globalTitle": "Chưa có mục trưng bày",
  "showcase.none.userDesc": "Người dùng này chưa chia sẻ bất kỳ giao tiếp nào trong bộ sưu tập.",
  "showcase.none.globalDesc": "Trở thành người đầu tiên chia sẻ giao tiếp AI của bạn trong bộ sưu tập!",
  "showcase.messageDetails": "Chi tiết tin nhắn",
  "showcase.field.date": "Ngày",
  "showcase.field.scenario": "Kịch bản",
  "showcase.field.target": "Mục tiêu",
  "showcase.field.tone": "Giọng điệu",
  "showcase.originalMessage": "Tin nhắn gốc",
  "showcase.description": "Mô tả",
  "showcase.aiResponse": "Phản hồi AI",

  // Templates
  "templates.saveAsTemplate": "Lưu làm mẫu",
  "templates.saved": "Đã lưu mẫu",
  "templates.saveSuccess": "Đã lưu mẫu thành công",
  "templates.title": "Mẫu của tôi",
  "templates.new": "Mẫu mới",
  "templates.loading": "Đang tải...",
  "templates.none": "Không tìm thấy mẫu",
  "templates.name": "Tên",
  "templates.scenario": "Kịch bản",
  "templates.target": "Mục tiêu",
  "templates.tone": "Giọng điệu",
  "templates.description": "Mô tả",
  "templates.save": "Lưu",
  "templates.saving": "Đang lưu...",
  "templates.delete": "Xóa mẫu",
  "templates.deleteConfirm": "Xóa mẫu này?",
  "templates.deleteFailed": "Xóa mẫu không thành công",
  "templates.nameRequired": "* Vui lòng nhập tên mẫu",
  "templates.deleteSuccess": "Đã xóa mẫu thành công",

  // History Modal additions
  "history.messageDetails": "Chi tiết tin nhắn",
  "history.messageDetailsDesc": "Xem và quản lý chi tiết tin nhắn, bao gồm đầu vào gốc và phản hồi AI được tạo.",
  "history.field.date": "Ngày",
  "history.field.scenario": "Kịch bản",
  "history.field.target": "Mục tiêu",
  "history.field.tone": "Giọng điệu",
  "history.originalMessage": "Tin nhắn gốc",
  "history.aiResponse": "Phản hồi AI",
  "history.description": "Mô tả",
  "history.listTitle": "Lịch sử tin nhắn",
  "history.listDesc": "Duyệt, lọc và quản lý lịch sử cuộc trò chuyện của bạn. Nhấp vào bất kỳ tin nhắn nào để xem chi tiết.",
  "history.sortBy": "Sắp xếp theo:",
  "history.sort.newest": "Mới nhất trước",
  "history.sort.oldest": "Cũ nhất trước",
  "history.sort.scenario": "Theo kịch bản",
  "history.sort.target": "Theo mục tiêu",
  "history.sort.tone": "Theo giọng điệu",
  "history.filter.scenario": "Kịch bản:",
  "history.filter.target": "Mục tiêu:",
  "history.filter.tone": "Giọng điệu:",
  "history.filter.all": "Tất cả",
  "history.loading": "Đang tải lịch sử...",
  "history.loadingMore": "Đang tải thêm...",
  "history.none": "Không tìm thấy tin nhắn",
  "history.showing": "Hiển thị {current} trong số {total} tin nhắn",
  "history.allLoaded": "Đã tải tất cả tin nhắn",
  "history.scrollMore": "Cuộn xuống để xem thêm",
  "history.loadMoreButton": "Tải thêm",
  "history.deleteMessage": "Xóa tin nhắn",
  "history.deleting": "Đang xóa...",
  "history.deleteSuccess": "Đã xóa bản ghi tin nhắn thành công",
  "history.deleteFailed": "Xóa bản ghi tin nhắn không thành công, vui lòng thử lại",
  "history.confirmDeleteTitle": "Xác nhận xóa",
  "history.confirmDeleteSubtitle": "Hành động này không thể hoàn tác",
  "history.confirmDeleteDesc": "Bạn có chắc chắn muốn xóa bản ghi tin nhắn này không?",
  "history.confirmDeleteAction": "Xác nhận xóa",
  "history.shareTitle": "Chia sẻ tới bộ sưu tập",
  "history.shareSubtitle": "Công khai tin nhắn này",
  "history.sharing": "Đang chia sẻ...",
  "history.confirmShareAction": "Xác nhận chia sẻ",
  "history.shareSuccess": "Đã chia sẻ tin nhắn thành công tới bộ sưu tập",
  "history.shareFailed": "Chia sẻ tới bộ sưu tập không thành công, vui lòng thử lại",
  "templates.saveFailed": "Lưu mẫu không thành công",

  // User Menu
  "userMenu.myAccount": "Tài khoản của tôi",
  "userMenu.history": "Lịch sử",
  "userMenu.templates": "Mẫu",
  "userMenu.signOut": "Đăng xuất",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Xem trước phản hồi AI",
  "hero.preview.scenarioLabel": "Kịch bản",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Mở đầu bán hàng",
  "demo.shortTitle.priceObjection": "Phản đối giá",
  "demo.shortTitle.interviewIntro": "Giới thiệu phỏng vấn",
  "demo.shortTitle.emailReply": "Phản hồi email",
  "demo.shortTitle.followUp": "Theo dõi",
  "demo.shortTitle.elevatorPitch": "Bài thuyết trình thang máy",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "phản hồi",
  "demoTabs.inputPrompt": "NHẮC NHỞ ĐẦU VÀO",
  "demoTabs.context": "BỐI CẢNH",
  "demoTabs.description": "Mô tả",
  "demoTabs.generate": "Tạo",
  "demoTabs.aiOutput": "ĐẦU RA AI",
  "demoTabs.sample": "mẫu",
  "demoTabs.streaming": "Luồng token...",
  "preview.section.scenarioTemplates.title": "Kịch bản & Mẫu",
  "preview.section.scenarioTemplates.subtitle": "Chọn nhanh một kịch bản hoặc áp dụng mẫu đã lưu. Mẫu điền trước mô tả/mục tiêu/giọng điệu để bạn có thể trực tiếp bắt đầu tạo chất lượng cao.",
  "preview.section.customInputs.title": "Đầu vào tùy chỉnh",
  "preview.section.customInputs.subtitle": "Đầu vào cốt lõi + mô tả tùy chọn + bộ chọn Kịch bản/Mục tiêu/Giọng điệu nâng cao. Kết hợp tự do để có kết quả nhận thức bối cảnh.",
  "preview.section.cutReplyTime.title": "Giảm 90% thời gian phản hồi",
  "preview.section.cutReplyTime.subtitle": "So sánh soạn thảo thủ công với trợ giúp AI. Tùy chọn song song + vòng lặp dịch hoặc sửa đổi tích hợp.",
  "preview.section.copyShare.title": "Sao chép & Chia sẻ một cú nhấp",
  "preview.section.copyShare.subtitle": "Nhiều tùy chọn được sắp xếp với hành động trên cùng hợp nhất: sao chép tất cả / chia sẻ / sao chép từng tùy chọn. Bản dịch được đính kèm tự động.",
  "preview.templates.my": "Mẫu của tôi",
  "preview.templates.new": "Mới",
  "preview.manualFlow": "Luồng thủ công",
  "preview.aiAssisted": "Được hỗ trợ bởi AI",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Lên kế hoạch cấu trúc & giọng điệu",
  "preview.manualFlow.step2": "Soạn thảo mở đầu / xóa & viết lại",
  "preview.manualFlow.step3": "Điều chỉnh lịch sự & ngữ pháp",
  "preview.manualFlow.step4": "Tìm từ vựng + xác minh bản dịch",
  "preview.manualFlow.step5": "Dán vào ứng dụng mục tiêu",
  "preview.copyAll": "Sao chép tất cả",
  "preview.share": "Chia sẻ",
  "preview.enPlusTranslation": "EN + Bản dịch",
  "preview.translationAppendNote": "(*) Bản dịch được đính kèm tự động khi sao chép tất cả.",
  "preview.field.scenario": "Kịch bản",
  "preview.field.target": "Mục tiêu",
  "preview.field.tone": "Giọng điệu",
  "preview.auto": "Tự động",
  "preview.step.pasteOrTemplate": "Dán yêu cầu hoặc chọn mẫu",
  "preview.step.optionalDescription": "(Tùy chọn) thêm mô tả/kịch bản",
  "preview.step.pickOption": "Chọn một trong các tùy chọn được tạo",
  "preview.step.copyShareTranslate": "Sao chép/chia sẻ/dịch một cú nhấp",
  "preview.time.manual": "5–8 phút",
  "preview.time.ai": "30–40 giây"
};